export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 11;
export const KEY = '08cc07ab-f022-47e1-92e9-213280a02a64';
export const MODAL_CLOSE_SEC = 2.5;
